module.exports = __webpack_public_path__ + "static/media/23-robot.7364e7c6.svg";